import { render, staticRenderFns } from "./carts-partner.vue?vue&type=template&id=415ce118&scoped=true"
import script from "./carts-partner.vue?vue&type=script&lang=js"
export * from "./carts-partner.vue?vue&type=script&lang=js"
import style0 from "./carts-partner.vue?vue&type=style&index=0&id=415ce118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415ce118",
  null
  
)

export default component.exports